<div
  class="dialog-footer"
  [attr.data-type]="type"
  [ngStyle]="dialogFooterStyle"
>
  <div class="button-group">
    @if (tertiaryButtonLabel) {
      <umss-button
        [label]="tertiaryButtonLabel"
        [variant]="tertiaryButtonVariant"
        [size]="buttonSize"
        [disabled]="tertiaryButtonDisabled || loading"
        [leftIconName]="tertiaryButtonLeftIconName"
        [rightIconName]="tertiaryButtonRightIconName"
        [loading]="tertiaryButtonLoading ?? false"
        (onClick)="handleTertiaryClick()"
      />
    }

    @if (secondaryButtonLabel) {
      <umss-button
        [label]="secondaryButtonLabel"
        [variant]="secondaryButtonVariant"
        [size]="buttonSize"
        [disabled]="secondaryButtonDisabled || loading"
        [leftIconName]="secondaryButtonLeftIconName"
        [rightIconName]="secondaryButtonRightIconName"
        [loading]="secondaryButtonLoading ?? false"
        (onClick)="handleSecondaryClick()"
      />
    }

    @if (primaryButtonLabel) {
      <umss-button
        [label]="primaryButtonLabel"
        [variant]="primaryButtonVariant"
        [size]="buttonSize"
        [disabled]="primaryButtonDisabled || loading"
        [leftIconName]="primaryButtonLeftIconName"
        [rightIconName]="primaryButtonRightIconName"
        [loading]="primaryButtonLoading ?? loading"
        (onClick)="handlePrimaryClick()"
      />
    }
  </div>
</div>
